var cookies = {}

export function readCookie(name) {
  if (cookies[name] === undefined) {
    var ckies = document.cookie.split(';')
    for (var i = 0; i < ckies.length; i++) {
      var cki = ckies[i].split('=')
      cookies[cki[0].trim()] = cki[1]
    }
  }
  return cookies[name]
}

export function createCookie(name, value, expire_days) {
  var d = new Date()
  d.setTime(d.getTime() + (expire_days * 86400 * 1000))
  var expires = "expires=" + d.toUTCString()
  document.cookie = `${name}=${value};${expires};path=/`
  cookies[name] = value
}